/**
 * The cache class for racing widgets
 * can be extended to support persistent
 * storages
 */
class Cache {
    /**
     * Constructor
     * creates data property
     */
    constructor() {
        this._data = {};
    }

    /**
     * setter for data property
     *
     * @param {Object} data Data to store in cache
     */
    set data(data) {
        this._data = {
            ...data,
        };
    }

    /**
     * getter for data property
     *
     * @returns {Object} Cached data
     */
    get data() {
        return this._data;
    }

    /**
     * Returns a cache according to a request sport slug
     *
     * @param {String} sportSlug sports slug of the widget
     * @returns {Object} cached data related to widget
     */
    getSportCache(sportSlug) {
        return this._data[sportSlug];
    }

    /**
     * Returns a cached depending on sport slug and race type
     *
     * @param {String} sportSlug sports slug of the widget
     * @param {String} type race type supperted by widget (next races|featured)
     * @returns {Object} cached data related to widget and race type
     */
    getCacheByType(sportSlug, type) {
        return this._data[sportSlug][type];
    }

    /**
     * Deletes a cached depending on sport slug and race type
     *
     * @param {String} sportSlug sports slug of the widget
     * @param {String} type race type supperted by widget (next races|featured)
     * @returns {this} self object
     */
    deleteCache(sportSlug, type) {
        delete this._data[sportSlug][type];

        return this;
    }

    /**
     * Checks if a certain type of sport and race type
     * and, optionally, event id exist in cache
     *
     * @param {String} sportSlug sports slug of the widget
     * @param {String} type race type supported by widget (next races|featured)
     * @param {*} eventId Optional
     * @returns {Boolean} Boolean value
     */
    hasCache(sportSlug, type, eventId = null) {
        try {
            if (eventId) {
                return Boolean(this._data[sportSlug][type].events[eventId]);
            }

            return Boolean(this._data[sportSlug][type]);
        } catch(e) {
            return false;
        }
    }

    /**
     * Checks if selections of a certain type of sport and race type
     * and, event id exist in cache
     *
     * @param {String} sportSlug sports slug of the widget
     * @param {String} type race type supported by widget (next races|featured)
     * @param {Number} eventId Event Id
     * @returns {Boolean} Boolean value
     */
    hasSelections(sportSlug, type, eventId) {
        try {
            return Boolean(this._data[sportSlug][type].selections[eventId]);
        } catch(e) {
            return false;
        }
    }
}

export default new Cache;
